import { ServerResponse } from 'http'
import { NextApiResponse } from 'next'

// Check if ServerResponse is NextApiResponse
export const responseHasRedirect = (
  res: ServerResponse | NextApiResponse
): res is NextApiResponse => {
  const maybeNextResponse = res as NextApiResponse
  return maybeNextResponse.redirect && typeof maybeNextResponse.redirect === 'function'
}

export const redirectResponse = <R extends ServerResponse>(
  res: R,
  location: string,
  status?: number
) => {
  if (responseHasRedirect(res)) {
    if (status) {
      res.redirect(status, location)
    } else {
      res.redirect(location)
    }
  } else {
    res.writeHead(status ?? 302, { Location: location })
    res.end()
  }
}
